var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top"},[_c('i',{staticClass:"icon icon--ba-back-to-top",on:{"click":_vm.onBackToTopClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }